module.exports = {"dashboard":"Dashboard","search":"Search","calendar":"Calendar","mailbox":"Mailbox","widgets":"Widgets","social":"Social","charts":"Charts","media":"Media","overlays":"Overlays","snackbar":"Snackbar","authorization":"Authorization","login":"Login","users":"Users","widgetTodaysVisit":"Today's Visit","widgetTodaysSale":"Today's Sales","widgetUniqueVisits":"% Unique Visits","widgetBounceRate":"Bounce Rate","widgetHigherYesterday":"{0} higher yesterday","widgetBeforeTax":"{0} before tax","widgetAverageDuration":"{0} average duration","widgetAverageTime":"{0}  on average time"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en.json
// module id = UpdR
// module chunks = 1